import type { Site } from '../schemas';
import { ActionsRepo } from '../repos/actionsRepo';

export const GU_PUBLICATION_ACTION_TITLE = 'Pubblicazione su Gazzetta Ufficiale mancante';

type ActionsGateway = Pick<typeof ActionsRepo, 'listBySite' | 'create' | 'markCompleted'>;

export async function syncGuPublicationAction(options: {
  companyId: string;
  site?: Site | null;
  actionsGateway?: ActionsGateway;
}): Promise<void> {
  const { companyId, site, actionsGateway = ActionsRepo } = options;

  if (actionsGateway === ActionsRepo && typeof indexedDB === 'undefined') {
    return; // Skip when IndexedDB is unavailable (e.g., during SSR/unit tests)
  }

  if (!site?.id) return;

  const hasAuthorization = Boolean(site.authorizationProtocolNumber && site.authorizationIssueDate);
  const missingGazetteDate = !site.officialGazetteDate;
  const shouldBeOpen =
    hasAuthorization && site.officialGazettePublished === true && missingGazetteDate;

  const existing = await actionsGateway.listBySite(companyId, site.id);
  const guActions = existing.filter(
    (action) => action.type === 'system' && action.title === GU_PUBLICATION_ACTION_TITLE
  );
  const openActions = guActions.filter((action) => action.status !== 'completed');

  if (shouldBeOpen && openActions.length === 0) {
    await actionsGateway.create({
      companyId,
      siteId: site.id,
      title: GU_PUBLICATION_ACTION_TITLE,
      type: 'system',
    });
    return;
  }

  if (!shouldBeOpen && openActions.length > 0) {
    await Promise.all(openActions.map((action) => actionsGateway.markCompleted(action.id)));
  }
}
